import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';

import { Editor } from 'libs/editor';
import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';

import { media } from 'legacyComponents/styled/styleUtils';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';
import {
  Card as BaseCard,
  GreyBar,
  AvatarWrapper,
} from 'legacyComponents/cards/styles';
import { Name as ProfileName } from 'apps/profile/views/profileName.styles';
import { DescriptionWrapper as ProfileDescriptionWrapper } from 'apps/profile/views/profileDescription.styles';
import { Center, ProfileUsername } from 'legacyComponents/styled/lib';
import { Avatar } from 'apps/components/shared';
import { Follow } from 'apps/content/views/follow';

import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

@withNamespaces()
@observer
export class ForumCard extends React.Component {
  render() {
    const { cardObject, cardNo, cardColumns } = this.props;

    const noMargin = (cardNo + 1) % cardColumns === 0;
    if (cardObject === null) {
      return <CardIndicator noMargin={noMargin} type='profile' />;
    }
    const { parentContent, description } = cardObject;
    const { content } = parentContent;

    const store = new EditorStore({
      initialValue: html.deserialize(description),
      formatting: 'basic',
    });

    return (
      <Card noMargin={noMargin}>
        <GreyBar />
        <AvatarWrapper>
          <Link
            name='initiative.forum'
            params={{ initiative: `+${parentContent.slug}` }}
            content={content}
          >
            <Avatar
              src={imageSrc(
                parentContent.avatar,
                parentContent.imageFallbackPath,
                mainConf.imgSizes.profile.large,
              )}
              size='80px'
              noOpacity={true}
            />
          </Link>
        </AvatarWrapper>
        <Link
          name='initiative.forum'
          params={{ initiative: `+${parentContent.slug}` }}
          content={content}
        >
          <Name>{parentContent.title}</Name>
        </Link>
        <Link
          name='initiative.forum'
          params={{ initiative: `+${parentContent.slug}` }}
          content={content}
        >
          <Username>+{parentContent.slug}</Username>
        </Link>
        <DescriptionWrapper>
          <Editor store={store} />
        </DescriptionWrapper>
        <ButtonWrapper>
          <Center>
            <Follow content={content} small />
          </Center>
        </ButtonWrapper>
      </Card>
    );
  }
}

const Card = styled(BaseCard)`
  height: 255px;
  ${media.s`
    height: 280px;
  `};
  ${media.xs`
    height: 265px;
  `};
`;

const Name = styled(ProfileName)`
  font-size: 1.1em;
  &:hover {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
  }
  ${media.xs`
    font-size: 0.925em;
  `};
`;

const Username = styled(ProfileUsername)`
  font-size: ${props => props.theme.font.size.xsmall};
  margin-top: ${props => props.theme.spacing.xsmall};
  &:hover {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
  }
`;

const DescriptionWrapper = styled(ProfileDescriptionWrapper)`
  margin: ${props =>
    `${props.theme.spacing.default} auto ${props.theme.spacing.medium}`};
  padding: 0 ${props => props.theme.spacing.default};
  font-size: ${props => props.theme.font.size.small};
  text-align: center;
  line-height: 1.4;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
`;

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.85) 85%,
    rgba(255, 255, 255, 0) 100%
  );
  width: 100%;
  padding: 15px 0;
`;

ForumCard.propTypes = {
  cardObject: PropTypes.object,
  cardColumns: PropTypes.number,
  cardNo: PropTypes.number,
};
